import InnerComponent from '@Components/ReportsV2/ReportListV2';
import orgContainer from '@Components/AppContainer';

const ReportsList = () => ((orgContainer(InnerComponent)));
export default ReportsList;
